'use strict';

const _ = require('underscore');
const Backbone = require('backbone');
const Idea = require('feedback/domain/entity/idea');
const IdeaComment = require('feedback/domain/entity/comment');
const IdeaStatsCollection = require('feedback/domain/collection/idea-stats');
const IdeaAPI = require('feedback/infra/api/idea');
const IdeaAdminAPI = require('feedback/infra/api/admin/idea');

class Repository {
    constructor() {
        _.extend(this, Backbone.Events);

        this._ideas = new Backbone.Collection();
        this._ideas.on('change:state', () => {
            IdeaStatsCollection.fetch();
        });
    }


    /**
     * @param id
     * @returns {*}
     */
    fetchByID(id) {
        if(this._ideas.get(id)) {
            return new Promise((resolve, reject) => {
                resolve(this._ideas.get(id));
            });
        }

        return IdeaAPI.getIdeaByID(id)
            .then(ideaJSON => {
                return this.add(new Idea(ideaJSON), {merge: true})[0];
            });
    }

    fetchCommentsByIdea(idea) {
        return IdeaAPI.fetchComments(idea.id)
            .then(response => {
                const comments = _.map(response.comments, commentJSON => {
                    return new IdeaComment(commentJSON);
                });

                return idea.comments.reset(comments);
            });
    }

    fetch(scope, limit=10, cursor=null, options) {
        if (scope === "my") {
            return this.fetchMyIdeas(limit, cursor, options);
        } else {
            return this.fetchPublicIdeas(limit, cursor, options);
        }
    }

    /**
     * @param limit
     * @param cursor
     * @param options
     * @returns {*}
     */
    fetchPublicIdeas(limit=10, cursor=null, options) {
        let pagination;

        return IdeaAPI.getPublicIdeas(limit, cursor, options)
            .then(ideaData => {
                const ideasJSON = ideaData.results;
                pagination = ideaData.pagination;

                return Promise.all(
                    _.map(ideasJSON, j => {
                        return new Idea(j);
                    })
                );
            })
            .then(ideas => {
                ideas = this.add(ideas, {merge: true});

                return {
                    models: ideas,
                    pagination: pagination
                };
            });
    }

    /**
     * @param limit
     * @param cursor
     * @param options
     * @returns {*}
     */
    fetchMyIdeas(limit=10, cursor=null, options) {
        let pagination;

        return IdeaAPI.getUserIdeas(limit, cursor, options)
            .then(ideaData => {
                const ideasJSON = ideaData.results;
                pagination = ideaData.pagination;

                return Promise.all(
                    _.map(ideasJSON, j => {
                        return new Idea(j);
                    })
                );
            })
            .then(ideas => {
                ideas = this.add(ideas, {merge: true});

                return {
                    models: ideas,
                    pagination: pagination
                };
            });
    }

    /**
     * @param limit
     * @param cursor
     * @param options
     * @returns {*}
     */
    fetchAdminByQuery(query, limit=10, cursor=null, options) {
        let pagination;

        return IdeaAdminAPI.getIdeasByQuery(query, limit, cursor, options)
            .then(ideaData => {
                const ideasJSON = ideaData.results;
                pagination = ideaData.pagination;

                return Promise.all(
                    _.map(ideasJSON, j => {
                        return new Idea(j);
                    })
                );
            })
            .then(ideas => {
                ideas = this.add(ideas, {merge: true});

                return {
                    models: ideas,
                    pagination: pagination
                };
            });
    }

    add(ideas) {
        if (!_.isArray(ideas)) {
            ideas = [ideas];
        }

        let addedIdeas = [];

        _.each(ideas, idea => {
            const trigger = !this._ideas.get(idea.id);
            idea = this._ideas.add(idea, {merge: true});

            if(trigger) {
                this.trigger('add', idea);
            }

            addedIdeas.push(idea);
        });

        return addedIdeas;
    }
}

module.exports = new Repository();



// WEBPACK FOOTER //
// ./feedback/domain/repository/idea.js